module.exports = __webpack_public_path__ + "0af5d249/img/archive-icon.0a6a9de3.svg";